/*
 * @Author: edvardchen
 * @Date:   2017-07-03 14:18:46
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2018-12-03 15:48:20
 */
import reportError from './error-report';
const knownErrors = [
  'x5onSkinSwitch is not defined',
  'qb_bridge.nativeExec is not a function',
  'tbs is not defined',
  'MtaH5 is not defined',
];
const report = ({ message, filename, lineno, colno, error }) => {
  if (knownErrors.some((item) => message.indexOf(item) > -1)) {
    console.error(message);
    return;
  }
  reportError({ message, filename, lineno, colno, error });
};
if (window.onunhandledrejection) {
  window.onunhandledrejection = (event = {}) => {
    report({ message: event.reason || '' });
  };
}
if (window.addEventListener) {
  window.addEventListener('error', report);
} else if (window.attachEvent) {
  window.attachEvent('onerror', report);
} else {
  window.onerror = report;
}
